import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { PatentOfficeNames } from '../constants';
import { selectPatentOffices } from '../../CSP-Form/selectors';

const usePatentOfficeOptions = () => {
  const patentOffices = useSelector(selectPatentOffices);

  return useMemo(
    () =>
      patentOffices.map((value) => ({
        label: (PatentOfficeNames as Record<string, string>)[value] ?? value,
        value,
      })),
    [patentOffices]
  );
};

export default usePatentOfficeOptions;
